<template>
  <base-modal :box="box_init" :step="step">
    <z-form ref="form" @submit.native.prevent="save">
      <form-input-name v-model="form.name" :box_type="box.type" />

      <z-form-group class="row">
        <div class="col-4 text-right">
          {{ $t('pbx.worksheet.action.entry.input.number_id.label') }}
        </div>
        <z-form-input :rules="{ required: true }" class="col-8 input-tooltip">
          <select-number-id
            v-model="form.params.number_id"
            @create-button="set_create_number_step"
          />
          <tooltip placement="top" max-width="180" theme="light" :content="$t('pbx.worksheet.action.entry.input.number_id.tooltip')">
            <icon type="ios-help-circle-outline" />
          </tooltip>
        </z-form-input>
      </z-form-group>

      <z-form-group class="row">
        <div class="col-4 text-right">
          {{ $t('pbx.worksheet.action.entry.input.caller_id.label') }}
        </div>
        <z-form-input class="col-8 input-tooltip">
          <select-caller-id v-model="form.params.caller_id" />
          <tooltip placement="top" max-width="200" theme="light" :content="$t('pbx.worksheet.action.entry.input.caller_id.tooltip')">
            <icon type="ios-help-circle-outline" />
          </tooltip>
        </z-form-input>
      </z-form-group>

      <z-form-group class="row">
        <div class="col-4 text-right">
          {{ $t('pbx.worksheet.action.entry.input.hide_incoming_number.label') }}
        </div>
        <z-form-input class="col-8">
          <z-switch v-model="form.params.hide_incoming_number" />
        </z-form-input>
      </z-form-group>

      <select-record-type v-model="form.params.record_type" @closeModal="$refs.btn_cancel.$el.click();" />
    </z-form>

    <i-button
      slot="footer-ok"
      slot-scope="{ is_button_loading }"
      type="success"
      size="large"
      :loading="is_button_loading"
      @click="save"
    >
      {{ $t('pbx.worksheet.modal.action.main.button.ok') }}
    </i-button>

    <template slot="footer-cancel" slot-scope="{ close }">
      <i-button size="large" @click="close()" ref="btn_cancel" >
        {{ $t('pbx.worksheet.modal.action.main.button.cancel') }}
      </i-button>
    </template>
    
  </base-modal>
</template>

<script>
  import BaseModal from '../../../_base/index';
  import FormInputName from '../../../_base/_fragments/form-input-name';
  import SelectNumberId from './select-number-id';
  import SelectCallerId from './select-caller-id';
  import SelectRecordType from './select-record-type';
  import { StepMixin } from '../../../_base/step-mixin';

  /**
   * props.box - автоматически прокидывается в form
   * чтобы сохранить состояние шага, используй mixin_save_step из StepMixin
   */

  export default {
    components: { BaseModal, FormInputName, SelectNumberId, SelectCallerId, SelectRecordType },
    mixins: [StepMixin],

    methods: {
      save: function() {
        this.$refs.form.validate().then(is_valid => {
          if (is_valid) {
            const box = this.mixin_get_box(this.form);
            this.$emit('on-save', box);
          }
        });
      },

      set_create_number_step() {
        this.mixin_save_step(this.form);
        this.mixin_set_step('create-number');
      }
    }
  };
</script>
